<div class="right-navbar">
    <div class="top-container">
        <p>Your Cart:</p>
        <mat-icon (click)="closeNavbar()" class="close-icon">close</mat-icon>
    </div>
    <div class="separate"></div>
    
    <div class="middle-container">
        @for (item of products; let i = $index; track i) {
        <div class="item-content-block">
            <div class="item-content">
                <div class="left-content">
                    <div class="image-container" (click)="onClickProduct(item.product.id)">

                        <span
                            class="discount-badge font-inter"
                            *ngIf="item.product.discountedPrice">
                            {{ item.product.discountPercentage }}% OFF
                        </span>
                        <img
                            class="image"
                            [class]="'product-image-gradient' + ((i % 3) + 1)"
                            *ngIf="item.product.images; else placeholder"
                            [src]="item.product.images.imagesUrl[0]"
                            alt="Item Image"
                        />
                        <ng-template #placeholder>
                            <div class="image-placeholder"></div>
                        </ng-template>
                    </div>
                </div>
                <div class="right-content">
                    <p
                        [matTooltipShowDelay]="800"
                        [matTooltipHideDelay]="500"
                        [matTooltip]="item.product.name"
                        matTooltipPosition="above"
                    >
                        {{ item.product.name }}
                    </p>
                    <span class="multicolor font-inter " *ngIf="!item.product.category.includes(categories.BuyBlocks)">Color:Muticolor</span>

                    <div class="node-hole-plane-config" *ngIf="item.product.category.includes(categories.BuyBlocks)">
                            
                        <div *ngIf="getFacesByType(item, 'Plane').length > 0" class="plane-config font-inter">
                            <span class="block-face-label">{{ "cart.shapeFacetype.plane" | translate }}: </span>
                            <span class="block-face-value">{{ getFacesByType(item, "Plane") }}</span>
                        </div>

                        <div *ngIf="getFacesByType(item, 'Hole').length > 0" class="hole-config font-inter">
                            <span class="block-face-label">{{ "cart.shapeFacetype.hole" | translate }}: </span>
                            <span class="block-face-value">{{ getFacesByType(item, "Hole") }}</span>
                        </div>

                        <div *ngIf="getFacesByType(item, 'Node').length > 0" class="node-config font-inter">
                            <span class="block-face-label">{{ "cart.shapeFacetype.node" | translate }}: </span>
                            <span class="block-face-value">{{ getFacesByType(item, "Node") }}</span>
                        </div>

                    </div>
                    <div class="price-content">
                        <span *ngIf="item.product.discountedPrice; else noDiscount">
                            <span class="price">{{ "currency.rs" | translate }}{{ item.product.discountedPrice }}</span>
                            &nbsp;
                            <s class="cut-price font-inter">{{ "currency.rs" | translate }}{{ item.product.price }}</s>
                        </span>
                        &nbsp;
                        <ng-template #noDiscount>
                            <span class="price">₹ {{ item.product.price }}</span>
                        </ng-template>
                    </div>

                    <div class="quantity-delete">
                        <div class="quantity-container">
                            <span
                                ><button
                                    class="decrement"
                                    (click)="onClick(-1, item.product.id, item.cartUUID!)"
                                    [disabled]="getProductQtyInCart(item.product.id, item.cartUUID!) <= minQuantity"
                                >
                                    -
                                </button></span
                            >
                            <input
                                type="number"
                                class="font-inter"
                                [value]="getProductQtyInCart(item.product.id, item.cartUUID!)"
                                (input)="onInputChange($event, item.product.id, item.cartUUID!)"
                                (blur)="onBlur($event, item.product.id, item.cartUUID!)"
                            />
                            <span
                                ><button
                                    class="increment"
                                    (click)="onClick(1, item.product.id, item.cartUUID!)"
                                    [disabled]="getProductQtyInCart(item.product.id, item.cartUUID!) >= maxQuantity"
                                >
                                    +
                                </button></span
                            >
                        </div>
                        
                        <span class="delete font-inter" (click)="onDeleteCartItem(item)"> <mat-icon [svgIcon]="'bin'" class="bin-icon">delete</mat-icon> {{
                            "cart.label.remove" | translate
                        }}</span>
                    </div>
                </div>
            </div>
           

            <div class="block-item-info-container" *ngIf="item.product.category.includes(categories.BuyBlocks)">
                <div class="color-config">
                    <div class="color-title-section">
                        <mat-icon [svgIcon]="'color'" class="color-icon"></mat-icon>
                        <p class="color-title">Color configuration</p>
                    </div>

                    <div class="color-info">
                        <div *ngFor="let color of getFaceColors(item.singleBlockInfo?.color)">
                            <div class="color-item">
                                <div
                                    class="color-box"
                                    [ngStyle]="{ 'background-color': getColorValue(color.value) }"
                                ></div>
                                <div class="color-name">
                                    <span class="block-face-label font-inter">{{ color.key }} </span>
                                    <span class="block-face-value font-i">
                                        {{ color.value }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>

    <div class="separate"></div>
    <div class="bottom-section">
        <div class="price-details">
            <p class="price-details-heading">Price Details</p>
            <br />
            <p class="mrp-value  font-inter">
                <span>Subtotal({{totalItemsCount}} items)</span> <span class="totoal">₹ {{ totalMRP }}</span>
            </p>
            <p class="discount-mrp font-inter">
                <span>Discount</span> <span class="red">- ₹ {{ totalDiscount }}</span>
            </p>

            <p class="discount-mrp font-inter">
                <span>Delivery Fee</span> <span class="red">FREE</span>
            </p>
            <div class="separator font-inter"></div>
            <p class="totl-amount">
                <span>Total Amount</span> <span>₹ {{ totalAmount }}</span>
            </p>
        </div>

        <div class="action-buttons-wrapper">
            <div class="saving">
                <mat-icon class="maticon" svgIcon="tickmark"></mat-icon> 
                <span class="saving-text font-inter"
                >You're saving {{ totalMRP - totalAmount | currency: "INR" }} on
                this order!
                </span>
            </div>
            <div class="proceed-continue">
                <button mat-stroked-button class="checkout-button font-poppins" (click)="onCheckout()">
                <span class="button-text">Proceed to Checkout</span>
                <mat-icon 
                    [svgIcon]="'rightarr'"
                    iconPositionEnd
                    class="checkout-icon"
                ></mat-icon>
                </button>

            <button
            (click)="closeNavbar()"
            mat-stroked-button
            class="continue-shopping-button font-poppins"   
            >

            <mat-icon [svgIcon]="'cart'" class="cart-icon"></mat-icon>
             <span class="button-text">Continue Shopping</span>
            </button>
            </div>

            <div class="secure-section">

                <div class="section">
                  <mat-icon
                    [svgIcon]="'secure'"
                    class="secure-icon"
                  ></mat-icon>
                  <span class="secure-text">100% Secure Payments</span>
                </div>
                <div class="section">

                    <mat-icon
                        [svgIcon]="'truck'"
                        class="secure-icon"
                    ></mat-icon>
                    <span class="secure-text"
                        >Free Delivery on orders above
                       </span
                    >
                </div>

                <div class="section">
                  <mat-icon [svgIcon]="'refresh'" class="secure-icon"></mat-icon>
                  <span class="secure-text">Easy 7-day Returns</span>
                </div>
            </div>  
        </div>
    </div>
</div>
